module.exports = "./dist/DINPro-Medium.otf?b7b126d012bc1391761dccdeca88126a";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DINPro-Medium.otf
// module id = 5
// module chunks = 0